import { render, staticRenderFns } from "./grbdata.vue?vue&type=template&id=7b7ef4de&"
import script from "./grbdata.vue?vue&type=script&lang=js&"
export * from "./grbdata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports